import { JSX } from "react";
import { appContext } from "../../../AppContext";
import { IbssPage } from "../../../Components/Core/BasePage/IbssPage"
import Header, { IProps as IHeaderProps } from "../../../Components/Layout/Header/Header";
import Sidebar from "../../../Components/Layout/Sidebar/Sidebar";
import "../Styles.scss";

export default class NotSupported extends IbssPage<{}, {}>
{
    public componentDidMount(): void
    {
        this.pageTitle = appContext().labels.FadxNotSupportedByApi;
    }

    public render(): JSX.Element
    {
        return (
            <div className="page-container">
                <Sidebar {...this.props} />
                <div className="rightPanel">
                    <Header {...this.props as unknown as IHeaderProps} />
                    <div className="redirectContainer">
                        <div className="card">{appContext().labels.FadxNotSupportedByApi}</div>
                    </div>
                </div>
            </div>
        );
    }
}